import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  provider: string;
}

const GenericCallback: React.FC<Props> = ({ provider }) => {
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    // If token is present, store and reload (for SSO flows)
    const token = params.get('token');
    if (token) {
      localStorage.setItem('jwtToken', token);
      window.location.reload();
      return;
    }
    // If success param, fetch profile and redirect
    if (params.get('success')) {
      // Optionally, fetch profile or connected accounts here
      setTimeout(() => {
        navigate('/');
      }, 1000);
    } else {
      // Error or direct access
      setTimeout(() => {
        navigate('/auth/login');
      }, 1500);
    }
  }, [provider, navigate]);
  return <div>Logging in with {provider}...</div>;
};

export default GenericCallback;
